import NotificationPoint from './NotificationPoint'
import NotificationBell from './NotificationsBellPoint'
import Notification from './Notification'

export {
  NotificationPoint,
  NotificationBell
}

export default Notification



// WEBPACK FOOTER //
// ./src/app/components/common/notifications/index.js